/*
 * Student/parent exam screens (list, detail, report cards, performance).
 *
 * Prefixed `SP_EXAM_` so no other saga can take them: the older
 * `GET_STUDENT_EXAMS` string is registered by BOTH `examSagas` and
 * `studentExamSagas`, so every dispatch of it fired the request twice.
 */
export const SP_EXAM_GET_EXAMS = 'SP_EXAM_GET_EXAMS'
export const SP_EXAM_GET_EXAM = 'SP_EXAM_GET_EXAM'
export const SP_EXAM_GET_EXAM_TYPES = 'SP_EXAM_GET_EXAM_TYPES'
export const SP_EXAM_GET_TERMS = 'SP_EXAM_GET_TERMS'
export const SP_EXAM_GET_REPORT_CARDS = 'SP_EXAM_GET_REPORT_CARDS'
export const SP_EXAM_GET_REPORT_CARD = 'SP_EXAM_GET_REPORT_CARD'
export const SP_EXAM_GET_REPORT_CARD_PDF = 'SP_EXAM_GET_REPORT_CARD_PDF'
export const SP_EXAM_GET_PERFORMANCE = 'SP_EXAM_GET_PERFORMANCE'
